interface TickerItem {
	mint: string
	ticker: string
	name: string
	icon: string | null
	market_cap: number | null
	price_change_24h: number | null
	is_verified: boolean
}

function formatMarketCap(mcap: number): string {
	if (mcap >= 1e9) {
		return `${(mcap / 1e9).toFixed(1)}B`
	}
	if (mcap >= 1e6) {
		return `${(mcap / 1e6).toFixed(1)}M`
	}
	if (mcap >= 1e3) {
		return `${(mcap / 1e3).toFixed(1)}K`
	}
	return mcap.toFixed(0)
}

interface TickerSuggestionsProps {
	items: TickerItem[]
	onSelect: (ticker: string) => void
	selectedIndex: number
}

export function TickerSuggestions({ items, onSelect, selectedIndex }: TickerSuggestionsProps) {
	if (items.length === 0) {
		return null
	}

	return (
		<div className="max-h-[260px] overflow-y-auto border-app-border border-t bg-app-surface">
			{items.map((item, index) => (
				<button
					className={`flex w-full items-center gap-2.5 px-3 py-2 text-left transition-colors hover:bg-app-surface-light ${
						index === selectedIndex ? "bg-app-surface-light" : ""
					}`}
					key={item.mint}
					onMouseDown={e => {
						e.preventDefault()
						onSelect(item.ticker)
					}}
					type="button"
				>
					{item.icon ? (
						<img alt="" className="h-9 w-9 rounded-full" src={item.icon} />
					) : (
						<div className="h-9 w-9 rounded-full bg-app-surface-light" />
					)}
					<div className="min-w-0 flex-1">
						<div className="truncate font-semibold text-app-text text-sm">{item.name}</div>
						<div className="flex items-center gap-1 text-app-text-secondary text-xs">
							<span>${item.ticker}</span>
							<span className="text-app-text-tertiary">
								{item.mint.slice(0, 4)}...{item.mint.slice(-4)}
							</span>
						</div>
					</div>
					<div className="text-right">
						{item.market_cap != null && item.market_cap > 0 && (
							<div className="font-semibold text-app-text text-sm">
								${formatMarketCap(item.market_cap)}
							</div>
						)}
						{item.price_change_24h != null && (
							<div
								className={`font-semibold text-xs ${item.price_change_24h >= 0 ? "text-app-green" : "text-app-red"}`}
							>
								{item.price_change_24h >= 0 ? "+" : ""}
								{item.price_change_24h.toFixed(1)}%
							</div>
						)}
					</div>
				</button>
			))}
		</div>
	)
}
